<template>
  <v-app id="org-registration-app" class="orgRegistration">
    <div class="registrationContainer">
      <progress-tracker
          :steps="steps">
      </progress-tracker>
      <img
        class="logo"
        :src="darkMode?brandingService.getLoginDarkLogoUrl():brandingService.getLoginLogoUrl()"
        alt="brandingService.getLoginLogoAlt()"
      />
      <section class="middle form" v-if="!submitted && !termsStep">
        <h1>My Info</h1>
        <div class="panels">
          <div class="leftPanel">
            <h3>User Name & Password</h3>
            <v-text-field
              v-model="email"
              class="email"
              solo
              flat
              disabled
              outlined
              dense
            ></v-text-field>
            <PasswordEntry class="v-adjust" @password-updated="updatePassword"></PasswordEntry>
          </div>
          <div class="rightPanel">
            <h3>Company Info</h3>
            <v-text-field
              v-model="companyName"
              class="companyName"
              solo
              flat
              outlined
              dense
              label="Company Name"
            ></v-text-field>
            <v-autocomplete
                solo
                flat
                outlined
                dense
                :autofocus="false"
                autocomplete="off"
                v-model="timeZone"
                :items="timeZoneItems"
                class="timeZone"
                label="Time Zone"
                @input="timeZoneChanged"
              ></v-autocomplete>
          </div>
        </div>
        <v-btn
          class="submit"
          color="#024ad8"
          block
          depressed
          :disabled="validateFields()"
          @click="nextStep"
        >Next</v-btn>
      </section>
      <section class="middle terms" v-if="!submitted && termsStep">
        <section v-if="!managing" class="defaultBody">
          <h3>Optional Privacy Consents</h3>
          <p class="documents">Agree to HP collecting and using your personal data to provide, develop, and improve the quality of our service, security, products, applications and operations, to deliver products and drive continuous improvements.</p>
          <button class="consentButton btn btn-primary" @click="submitEmail(true)">Accept All</button>
          <button class="consentButton btn btn-default" @click="manage">Manage Options</button>
        </section>
        <section v-if="managing" class="manageBody">
          <h3>Optional Privacy Consents</h3>
          <v-checkbox
              v-model="orgDataConsent"
              class="communications"
              label="Agree to HP collecting and using your personal data to provide, develop, and improve the quality of our service, security, products, applications and operations, to deliver products and drive continuous improvements."
              hide-details
          ></v-checkbox>
          <button class="consentButton btn btn-primary" @click="submitEmail(false)">Save</button>
          <button class="consentButton btn btn-default" @click="manage">Cancel</button>
        </section>
      </section>
      <section class="middle submitted" v-if="submitted">
        <section v-if="!submitError" class="submittedSuccess">
          <h1>Finished</h1>
          <p class="message">You're ready to start using WXP Collaboration.</p>
          <p class="message"><a href="/">Log in</a></p>
        </section>
        <section v-if="submitError" class="submittedError">
          <h1>Something Went Wrong</h1>
          <p class="message">There was an error processing your request.</p>
          <p class="message">Please contact <a :href="getSupportContactUrl()">support</a> for further assistance with this issue.</p>
        </section>
      </section>
      <p class="copywrite">© {{currentYear}} HP Inc. <a href="https://www.hp.com/us-en/privacy/privacy-central.html" target="_blank">Privacy Statement</a>,
        <a href="https://support.hp.com/us-en/document/ish_12775809-12775790-16" target="_blank">EULA</a>,
        and <a href="https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf" target="_blank">DPA</a>
      </p>
    </div>
  </v-app>
</template>

<script>
  import BrandingService from '../../../../services/branding.service';
  import ConfigService from '../../../../services/config.service';
  import PasswordEntry from '../../../../components/password-setup-view/PasswordEntry.component.vue';
  import ProgressTracker from '../../../../vueComponents/progressTracker/src/progressTracker.vue';
  import {TZ_DISPLAY_MAP_ORG} from '../../../admin/models/timezone.model'
  import 'whatwg-fetch';
  import moment from "moment-timezone";

  let steps = [
    {
      name: 'create',
      display: 'Create',
      completion: 100,
      active: false
    },
    {
      name: 'verify',
      display: 'Verify',
      completion: 100,
      active: false
    },
    {
      name: 'info',
      display: 'My Info',
      completion: 50,
      active: true
    },
    {
      name: 'finished',
      display: 'Finished',
      completion: 0,
      active: false
    },
  ];

  export default {
    name: 'org-registration',
    props: {
      email: {
        type: String,
        default: '',
      },
      token: {
        type: String,
        default: '',
      },
    },
    components: {
      PasswordEntry,
      'progress-tracker': ProgressTracker,
    },
    data: function() {
      return {
        brandingService: BrandingService,
        darkMode: document.documentElement.classList.contains('dark'),
        password: '',
        companyName: '',
        timeZone: '',
        timeZoneItems: Object.entries(TZ_DISPLAY_MAP_ORG).map((a,b) => {return {text:a[1], value:a[0]}}),
        steps: steps,
        termsStep: false,
        submitted: false,
        submitError: '',
        currentYear: moment().year(),
        // terms of service variables
        managing: false,
        orgDataConsent: false,
      };
    },
    created: function() {
    },
    methods: {
      emailUpdated: function(newValue) {
        //validation
      },
      getSupportContactUrl: function() {
        return this.brandingService.getSupportContactUrl();
      },
      manage: function() {
        this.managing = !this.managing;
      },
      nextStep: function() {
        this.termsStep = true;
      },
      submitEmail: function(acceptAll) {
        let self = this;
        ConfigService.getInstance().getAdminService().then(function (serviceUrl) {
          window.fetch(serviceUrl + '/userreg/api/v1/user_requests', {
            method: 'PUT',
            body: JSON.stringify({
              token: self.token,
              password: self.password,
              companyName: self.companyName,
              timezone: self.timeZone,
              dataOptIn: acceptAll || self.orgDataConsent,
            }),
            headers: {
              "Content-type": "application/json; charset=UTF-8"
            }
          }).then((res)  => {
            if (!res.ok) {
              self.submitError = res.statusText;
            }
            steps[2].completion = 100;
            steps[2].active = false;
            steps[3].completion = 100;
            steps[3].active = true;
            self.submitted = true;
          });
        });
      },
      timeZoneChanged: function(newTimeZone) {
        console.log(newTimeZone);
        this.timeZone = newTimeZone;
      },
      updatePassword: function(newPassword) {
        this.password = newPassword;
      },
      validateFields: function() {
        if (this.password.length >= ConfigService.getInstance().getPasswordMinimumLength()
            && this.companyName.length > 0 && this.timeZone.length > 0) {
          return false;
        }
        return true;
      },
    },
  }
</script>

<style lang="scss">
  .set-password-content.v-adjust {
    margin-top: -5px;
  }
  .orgRegistration {
    .progressTracker {
      margin-bottom: 62px;
      max-width: 465px;
    }
    .registrationContainer {
      width: 67%;
      margin: auto;
      text-align: center;
      .logo {
        height: 190px;
        margin: auto;
        padding-top: 50px;
        padding-bottom: 50px;
      }
      .middle {
        height: 450px;
        max-width: 700px;
        margin: auto;
        h1 {
          color: var(--text-color);
          text-align: center;
          font-size: 32px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          margin-bottom: 40px;
        }
        .panels {
          display: flex;
          justify-content: space-around;
          .leftPanel, .rightPanel {
            display: inline-block;
            min-height: 250px;
            flex: 1 1 10px;
            padding: 5px;
            h3 {
              text-align: left;
              color: #6D787E;
              font-size: 16px;
              font-style: normal;
              font-weight: 700;
              line-height: normal;
            }
          }
        }
        .email, .companyName, .timeZone {
          .v-label {
            font-size: 16px;
            font-weight: 500;
            color: #6D787E;
          }
          fieldset {
            height: 50px;
            border-radius: var(--text-input-border-radius);
            border-color: var(--stroke-decorative-default);
          }
          legend {
            display: none;
            border-radius: var(--border-radius);
            font-size: 16px;
          }
        }
        .subInstruction {
          text-align: left;
          color: #6D787E;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
          padding-left: 15px;
        }
        .submit {
          height: 50px;
          font-size: 14px;
          text-transform: capitalize;
          border-radius: var(--border-radius);
          letter-spacing: unset;
          margin-bottom: 30px;
          color: white;
        }
        .contracts {
          font-size: 15px;
          font-weight: 400;
          line-height: 18px;
          a {
            color:  var(--tmp-default-color);
          }
        }
        .message {
          margin-bottom: 50px;
        }
        a {
          color:  var(--tmp-default-color);
        }
       
        .documents {
          font-size: 18px;
          line-height: 27px;
          letter-spacing: unset;
          margin-bottom: 30px;
          a {
            color:  var(--tmp-default-color);
          }
        }
        .consentButton {
          margin-top: 75px;
          margin-right: 15px;
        }
        .v-input__slot {
            align-items: flex-start;
        }

        .v-input--selection-controls__input {
            margin-top: 2px;
        }
      }
    }
  }
</style>
